import {TopLevelMetricType} from 'common/types/reports/bookmark';
import {NullableString} from 'common/util/typescript';
import {
  isEventBasedEntry,
  isGroupedEntry,
  isMetricEntry,
  MetricEntry,
  MetricEntryBehavior,
  QueryEntry,
} from 'iron/common/query-builder/query-entry-section/types';

/**
 * Recursively handles nested behaviors for funnel event comparison.
 */
const getEventNameFromMetricEntryBehavior = (behavior: MetricEntryBehavior): NullableString | NullableString[] => {
  if (behavior.behaviors?.length) {
    return behavior.behaviors.flatMap(getEventNameFromMetricEntryBehavior);
  }
  return behavior.name;
};

const getEventNameFromEntry = (entry: QueryEntry | MetricEntry): NullableString | NullableString[] => {
  if (entry.type === TopLevelMetricType.NewFormulaEntry) {
    /** @todo(metrics) handle saved formula referenced metrics */
    return [];
  } else if (isMetricEntry(entry)) {
    if (entry.behavior.behaviors?.length) {
      return entry.behavior.behaviors.flatMap(getEventNameFromMetricEntryBehavior);
    }
    return entry.behavior.name;
  }
  if (isGroupedEntry(entry)) {
    return entry.event.map((event) => event.event.value);
  } else if (isEventBasedEntry(entry)) {
    return entry.event.value;
  }
  return [];
};

/**
 * Extracts event names from a single behavior or an array of behaviors.

* @returns An array of event names extracted from the given behavior(s).
 * If a behavior has nested behaviors, those will be recursively processed.
 */
export function getEventNamesFromEntries(entries: QueryEntry | MetricEntry | Array<QueryEntry | MetricEntry>) {
  entries = Array.isArray(entries) ? entries : [entries];

  return entries.flatMap(getEventNameFromEntry);
}
